import { render } from "./QuickAction.vue?vue&type=template&id=40233fd6&ts=true"
import script from "./QuickAction.vue?vue&type=script&lang=ts"
export * from "./QuickAction.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__